import SubmittedFormsContainer from "./SubmittedForms.container";

export default SubmittedFormsContainer;
